// constants.js

// Base operators available for all field types
export const BASE_OPERATORS = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'does not equal' },
  { value: 'is_empty', label: 'is empty' },
  { value: 'is_not_empty', label: 'is not empty' }
];

// Text field specific operators
export const TEXT_OPERATORS = [
  { value: 'contains', label: 'contains' },
  { value: 'does_not_contain', label: 'does not contain' },
  { value: 'starts_with', label: 'starts with' },
  { value: 'ends_with', label: 'ends with' }
];

// Number field specific operators
export const NUMBER_OPERATORS = [
  { value: 'greater_than', label: 'is greater than' },
  { value: 'less_than', label: 'is less than' },
  { value: 'greater_than_or_equal', label: 'is greater than or equal to' },
  { value: 'less_than_or_equal', label: 'is less than or equal to' }
];

// Date field specific operators
export const DATE_OPERATORS = [
  { value: 'is_before', label: 'is before' },
  { value: 'is_after', label: 'is after' },
  { value: 'is_on_or_before', label: 'is on or before' },
  { value: 'is_on_or_after', label: 'is on or after' },
  { value: 'is_within_days', label: 'is within days' },
  { value: 'is_before_today', label: 'is before today' },
  { value: 'is_after_today', label: 'is after today' },
  { value: 'is_today', label: 'is today' }
];

// Checkbox field specific operators
export const CHECKBOX_OPERATORS = [
  { value: 'is_checked', label: 'is checked' },
  { value: 'is_unchecked', label: 'is unchecked' }
];

// Select field specific operators
export const SELECT_OPERATORS = [
  { value: 'has_any_of', label: 'has any of' },
  { value: 'has_all_of', label: 'has all of' },
  { value: 'has_none_of', label: 'has none of' },
  { value: 'is_exactly', label: 'is exactly' }
];

// Legacy export for backward compatibility
export const CONDITION_OPERATORS = [
  ...BASE_OPERATORS,
  ...TEXT_OPERATORS,
  { value: 'is_after_today', label: 'is after today' },
  { value: 'is_before_today', label: 'is before today' }
];

// Get operators based on field type
export const getOperatorsForFieldType = (fieldType) => {
  const baseOps = [...BASE_OPERATORS];
  
  switch (fieldType?.toLowerCase()) {
    case 'text':
    case 'singlelinetext':
    case 'multilinetext':
    case 'richtext':
    case 'email':
    case 'url':
    case 'phonenumber':
      return [...baseOps, ...TEXT_OPERATORS];
    
    case 'number':
    case 'currency':
    case 'percent':
    case 'duration':
    case 'rating':
      return [...baseOps, ...NUMBER_OPERATORS];
    
    case 'date':
    case 'datetime':
    case 'createdtime':
    case 'lastmodifiedtime':
      return [...baseOps, ...DATE_OPERATORS];
    
    case 'checkbox':
      return [...baseOps, ...CHECKBOX_OPERATORS];
    
    case 'singleselect':
    case 'multipleselects':
      return [...baseOps, ...SELECT_OPERATORS, ...TEXT_OPERATORS];
    
    case 'attachment':
    case 'formula':
    case 'lookup':
    case 'rollup':
    case 'count':
    case 'multiplerecordlinks':
      return baseOps;
    
    default:
      return [...baseOps, ...TEXT_OPERATORS];
  }
};

// Operators that don't require a value
export const NON_VALUE_OPERATORS = [
  'is_empty', 
  'is_not_empty', 
  'is_after_today', 
  'is_before_today',
  'is_today',
  'is_checked',
  'is_unchecked'
];

// Group operators for condition groups
export const GROUP_OPERATORS = [
  { value: 'AND', label: 'AND' },
  { value: 'OR', label: 'OR' }
];

// Content types for create fields
export const CONTENT_TYPES = [
  { value: 'static', label: 'Static Value' },
  { value: 'scanned_value', label: 'Scanned QR Value' },
  { value: 'current_timestamp', label: 'Current Timestamp' },
  { value: 'validated_record', label: 'Validated Record Link' },
  { value: 'linked_record', label: 'Linked Record' }
];